export const ACCOUNT_LOCKED_ERROR = 'account_locked';
export const EMAIL_VERIFICATION_REQUIRED_ERROR = 'email_verification_required';
export const GENERIC_ERROR_MESSAGE =
  'Yikes! Something went wrong when trying to log in. If you keep having trouble, please contact support.';
export const MFA_ERROR = 'mfa_required';
export const PENDING_WORKSPACE_ACCESS_ERROR = 'pending_workspace_access';
export const SINGLE_SESSION_ERROR = 'single_session';
export const DASHBOARD_FALLBACK_URL_NAME = 'dashboard';
